import { atomWithReset } from "jotai/utils";

import type { VoucherListItem } from "../types";

export const createVoucherModalAtom = atomWithReset<{
  visible: boolean;
}>({
  visible: false
});

export const voucherApprovalModalAtom = atomWithReset<{
  visible: boolean;
  data: {
    voucherId: number;
  } | null;
}>({
  visible: false,
  data: null
});

export const deleteVoucherModalAtom = atomWithReset<{
  visible: boolean;
  data: VoucherListItem | null;
}>({
  visible: false,
  data: null
});
